/**
 * Tools Dashboard — Usage analytics tour (admin / metrics_admin)
 */

export const DASHBOARD_USAGE_TOUR_STEPS = [
  {
    id: 'welcome',
    title: 'Usage analytics',
    description:
      'Track adoption: sessions, active users, top tools, and trends across the catalog.',
    position: 'center',
  },
  {
    id: 'tabs',
    title: 'ROI and Usage tabs',
    description:
      'Usage sits next to Time Saved (ROI). Filters and charts below apply to this Usage view only.',
    element: '[data-tour="dashboard-tabs"]',
    position: 'bottom',
    spotlight: true,
  },
  {
    id: 'kpis',
    title: 'At-a-glance KPIs',
    description:
      'Catalog size, sessions, active users, and average rating for the selected date range.',
    element: '[data-tour="usage-kpis"]',
    position: 'bottom',
    spotlight: true,
  },
  {
    id: 'filters',
    title: 'Date range and type',
    description:
      'Narrow to 7 / 30 / 90 days, a custom range, or All — and filter by Gem vs App.',
    element: '[data-tour="usage-filters"]',
    position: 'bottom',
    spotlight: true,
  },
  {
    id: 'trends',
    title: 'Session trends',
    description:
      'Daily sessions and users over time. Select tools in the tables below to overlay comparisons on the chart.',
    element: '[data-tour="usage-trends"]',
    position: 'top',
    spotlight: true,
  },
  {
    id: 'top-tools',
    title: 'Top tools and users',
    description:
      'Leaderboards for tools and people. Click a row for deeper session or tool breakdowns.',
    element: '[data-tour="usage-leaderboards"]',
    position: 'top',
    spotlight: true,
  },
];
